import { render, staticRenderFns } from "./resize-message.vue?vue&type=template&id=4c651dad"
import script from "./resize-message.vue?vue&type=script&lang=js"
export * from "./resize-message.vue?vue&type=script&lang=js"
import style0 from "./resize-message.vue?vue&type=style&index=0&id=4c651dad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports